import { signal } from '@angular/core';
import { TCatalogGraphicOption } from '../model';

export const genderCatalog$$ = signal<TCatalogGraphicOption[]>([
  { key: 'זכר', value: 1, icon: 'gender-male-icon' },
  { key: 'נקבה', value: 2, icon: 'gender-female-icon' }
]);
